var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCanvasPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 662,
    height: 244,
    viewBox: "0 0 662 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.535 111.517L191.266 107.961L193.858 119.1L200.535 111.517Z",
    fill: "#002E68"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 422,
    height: 244,
    rx: 8,
    fill: "#0a60a1",
    fillOpacity: 0.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 244,
    rx: 8,
    fill: "#0a60a1",
    fillOpacity: 0.11
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 142,
    height: 33,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 21,
    width: 366,
    height: 33,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 142,
    width: 180,
    height: 33,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 142,
    width: 182,
    height: 33,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 456,
    y: 190,
    width: 182,
    height: 32,
    rx: 6,
    fill: "#002E68"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 65,
    width: 142,
    height: 33,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 109,
    width: 142,
    height: 33,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 153,
    width: 142,
    height: 34,
    rx: 6,
    fill: "white",
    fillOpacity: 0.45
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 197.5,
    width: 141,
    height: 32,
    rx: 5.5,
    stroke: "white",
    strokeDasharray: "2 2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 141.467,
    height: 33.033,
    rx: 6,
    transform: "matrix(0.989904 -0.141741 0.142409 0.989808 200.258 94.3027)",
    fill: "#002E68"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 141.467,
    height: 33.033,
    rx: 6,
    transform: "matrix(0.989904 -0.141741 0.142409 0.989808 198 92.0508)",
    fill: "#002E68"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 265.328,
    y: 108.889,
    width: 14.3556,
    height: 3.88889,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.914 113.312L261.075 117.209C260.678 117.753 260.479 118.423 260.511 119.103C260.544 119.783 260.806 120.429 261.253 120.931L266.614 126.951C267.149 127.553 267.906 127.896 268.701 127.896H275.247C278.647 127.896 280.914 125.708 280.914 122.062V109.563M276.664 110.396V109.563C276.664 106.229 280.914 106.229 280.914 109.563",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.914 113.312L261.075 117.209C260.678 117.753 260.479 118.423 260.511 119.103C260.544 119.783 260.806 120.429 261.253 120.931L266.614 126.951C267.149 127.553 267.906 127.896 268.701 127.896H275.247C278.647 127.896 280.914 125.708 280.914 122.062V109.563M276.664 110.396V109.563C276.664 106.229 280.914 106.229 280.914 109.563",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.414 110.395V108.246V110.395ZM272.414 107.478V108.246V107.478ZM276.664 110.395V108.246C276.664 104.913 272.414 104.913 272.414 108.246",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.414 110.395V108.246M272.414 107.478V108.246M276.664 110.395V108.246C276.664 104.913 272.414 104.913 272.414 108.246",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.414 110.395V108.247C272.414 104.914 276.664 104.914 276.664 108.247V110.395M268.164 110.395V107.479C268.164 104.145 272.414 104.145 272.414 107.479V110.395M263.914 117.687V107.479C263.914 106.899 264.138 106.342 264.536 105.932C264.935 105.522 265.475 105.291 266.039 105.291C267.212 105.291 268.164 106.101 268.164 107.31V110.395",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.414 110.395V108.247C272.414 104.914 276.664 104.914 276.664 108.247V110.395M268.164 110.395V107.479C268.164 104.145 272.414 104.145 272.414 107.479V110.395M263.914 117.687V107.479C263.914 106.899 264.138 106.342 264.536 105.932C264.935 105.522 265.475 105.291 266.039 105.291C267.212 105.291 268.164 106.101 268.164 107.31V110.395",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.388 218C133.515 179.223 130.265 128.108 197 113",
    stroke: "#002E68",
    strokeDasharray: "2 2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasPlaceholder);
export default __webpack_public_path__ + "static/media/canvas-placeholder.e2083b8d219567bfec993ccf2c03629d.svg";
export { ForwardRef as ReactComponent };